import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export enum ContactsListEmptyNoticeVariants {
  search = 'search',
}
const ContactListEmptyNoticeParts = [
  'container',
  'icon',
  'warningText',
  'descriptionText',
  'searchContextText',
  'contentStack',
] as const

const helpers = createMultiStyleConfigHelpers(ContactListEmptyNoticeParts)

export const ContactsListEmptyNoticeStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      bg: 'bg.subtle',
      pt: '2.5rem',
      px: '1.25rem',
    },
    icon: {
      height: 49,
      width: 66,
      boxSize: 'auto',
      color: 'border.default',
    },
    warningText: {
      textAlign: 'center',
      ...textStyles[textStyleKeys.Body1_Bold],
      color: 'fg.muted',
    },
    descriptionText: {
      textAlign: 'center',
      color: 'fg.muted',
      ...textStyles[textStyleKeys.Body2],
    },
    searchContextText: {
      textAlign: 'center',
      color: 'fg.default',
    },
    contentStack: {
      gap: '0.5rem',
    },
  },
  variants: {
    search: {
      icon: {
        height: 54,
        width: 54,
      },
    },
  },
})

export const useContactsListEmptyNoticeStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(
    ContactsListEmptyNoticeStyle,
    props,
  ) as MultiStyleType<typeof ContactListEmptyNoticeParts>
}
